import React from "react";
import { localize } from "redux-i18n";
import { GSGrid, SectionComponent, Icons, TextField } from "@components";

const ShareForm = ({ searchValue, handleChange, handleSearch, cols, employees, t }) => (
  <SectionComponent
    title={
      <div>
        <Icons.StepCircleIcon color="black" />
        <h5>{t("STEP_SELECT_AND_SEARCH_EMPLOYEE")}</h5>
      </div>
    }
    wrapperClassName="flex-column"
    defaultBorder
    hoverFeedback
    active
    compact
  >
    <div className="w-30 mx-auto pb-5">
      <label htmlFor="lastName" className="mt-3 font-weight-bold">
        {t("SEARCH_BY_SURNAME")}
      </label>
      <TextField
        id="lastName"
        onChange={handleChange}
        value={searchValue}
        className="search-tasks-wrap__search-input"
        onKeyDown={handleSearch}
      />
    </div>
    <GSGrid columns={cols} rows={employees} />
  </SectionComponent>
);

export default localize()(ShareForm);
